module.exports = __webpack_public_path__ + "img/Rectangle19top.a49f2b5a.svg";